export default __webpack_public_path__ + "static/media/keto-chocolate-bar.0e018d5b.png";